import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { casinoGamesTreeQueryKey } from "./casinoConfigurationGamesQueryKeys";
import { fetchCasinoGamesTree } from "./fetchCasinoGamesTree";

export function useCasinoGamesTree(search: string, options = {}) {
  return useQuery({
    queryKey: casinoGamesTreeQueryKey(search),
    queryFn: () => fetchCasinoGamesTree(search),
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
    ...options,
  });
}
